var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OutgoingReturnForm',{attrs:{"formTitle":"Buat Retur Obral","defaultDescription":"Obral"}})
}
var staticRenderFns = []

export { render, staticRenderFns }